var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var Order_Form_Extended = function () {
	this.$tabSections = $( '.tab-section' );
};

Order_Form_Extended.prototype.init = function () {

	this.$tabSections.each( function ( i, el ) {
		var tabSection = $( el ),
			tabs = tabSection.find( '.tab-content' );
		tabSection.find( 'li a' ).on( 'click', function ( e ) {
			e.preventDefault();
			var el = $( this ),
			li = el.parent(),
			click_el_already_open = li.hasClass( 'active' );
			tabSection.find( 'li' ).removeClass( 'active' );
			tabs.removeClass( 'active' );
			if ( ! click_el_already_open ) {
				li.addClass( 'active' );
				tabs.filter( '#tab-' + el.data( 'id' ) ).addClass( 'active' );
			}
			if ( $(window).width() < 1024 ) {
				window.scrollTo( 0, el.offset().top - 80 );
			}
		} );
	} );

};

module.exports = new Order_Form_Extended;
